<template>
  <div class="card">
    <div class="card-body">
      <div class="pt-4 pb-4 pl-5 pr-5 text-center flex-grow-1">
        <i :class="icon + ' font-size-80 mb-2 d-block'" />
        <div class="text-dark font-weight-bold font-size-28">{{text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'emptyTable',
  props: {
    text: {
      type: String,
      default: 'Lista sin elementos',
    },
    icon: {
      type: String,
      default: 'fe fe-inbox',
    },
  },
}
</script>
